export function normalizeTimeToHHMMSS(time: string): string {
  const match = time.trim().match(/(\d{1,2}):(\d{2})(?::(\d{2}))?/);
  if (!match) {
    throw new Error(`Invalid time format: ${time}. Expected format: HH:mm or HH:mm:ss`);
  }

  const hours = match[1].padStart(2, '0');
  const minutes = match[2];
  const seconds = (match[3] ?? '00').padStart(2, '0');
  return `${hours}:${minutes}:${seconds}`;
}

/**
 * Validate time string format (HH:mm:ss)
 */
export function validateTimeFormat(time: string): void {
  const timeRegex = /^([0-1][0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$/;
  if (!timeRegex.test(time)) {
    throw new Error(`Invalid time format: ${time}. Expected format: HH:mm:ss (e.g., "09:00:00")`);
  }
}

/**
 * Calculate duration in hours from two time strings in HH:mm:ss format
 */
export function calculateDurationHours(startTime: string, endTime: string): number {
  const [startHours, startMinutes, startSeconds] = startTime.split(':').map(Number);
  const [endHours, endMinutes, endSeconds] = endTime.split(':').map(Number);

  const startTotalSeconds = startHours * 3600 + startMinutes * 60 + startSeconds;
  const endTotalSeconds = endHours * 3600 + endMinutes * 60 + endSeconds;

  const durationSeconds = endTotalSeconds - startTotalSeconds;
  return durationSeconds / 3600; // Convert to hours
}

export function convertTimingDurationToHours(duration: number | undefined, durationUnit: string | undefined): number {
  if (duration === undefined) {
    return 0;
  }

  if (durationUnit === 'min') {
    return duration / 60;
  }
  if (durationUnit === 's') {
    return duration / 3600;
  }
  if (durationUnit === 'h' || !durationUnit) {
    return duration;
  }

  throw new Error(`Unsupported duration unit: ${durationUnit}`);
}

/**
 * Calculate end time from start time and duration in hours
 */
export function calculateEndTimeFromDuration(startTime: string, durationHours: number): string {
  const [hours, minutes, seconds] = startTime.split(':').map(Number);
  const startTotalSeconds = hours * 3600 + minutes * 60 + seconds;
  const durationSeconds = durationHours * 3600;
  const endTotalSeconds = startTotalSeconds + durationSeconds;

  const endHours = Math.floor(endTotalSeconds / 3600) % 24;
  const endMinutes = Math.floor((endTotalSeconds % 3600) / 60);
  const endSeconds = endTotalSeconds % 60;

  return `${endHours.toString().padStart(2, '0')}:${endMinutes.toString().padStart(2, '0')}:${endSeconds.toString().padStart(2, '0')}`;
}
